<template>
  <div>
    <div
      v-for="(field, key) in fieldsFiltered"
      :key="key"
      class="form-group form-row"
    >
      <div class="col-sm-4 col-lg-3">
        <div class="col-form-label">
          {{field.label}}
        </div>
      </div>
      <div class="col-sm-8 col-lg-9">
        <DisplayLocation
          v-if="field.type === 'location'"
          :value="value[key]"
          class="form-control-plaintext"
        />
        <InputDatetimeLocal
          v-else-if="field.type === 'datetime' && value[key]"
          :value="value[key]"
          class="form-control-plaintext bg-transparent"
          readonly
        />
        <DisplayImage
          v-else-if="field.type === 'image upload'"
          :value="field.getSrc ? field.getSrc(value, key) : value[key]"
        />
        <DisplayMasked
          v-else-if="field.type === 'masked'"
          :value="value[key]"
          v-bind="field.props"
        />
        <div
          v-else-if="field.type === 'link'"
          class="form-control-plaintext"
        >
          <router-link
            :class="field.read_only ? 'text-muted' : 'text-reset'"
            :to="field.getTo ? field.getTo(value) : ''"
            v-bind="field.props"
          >{{value[key]}}</router-link>
        </div>
        <div
          v-else-if="field.type === 'list' && value[key]"
          class="input-spacing"
        >{{value[key].join(', ')}}</div>
        <div
          v-else
          class="form-control-plaintext whitespace-pre-wrap text-break"
          :class="{'text-muted': field.read_only}"
        >{{value[key]}}</div>

        <small v-if="field.help_text" class="form-text text-muted">
          {{field.help_text}}
        </small>
      </div>
    </div>
  </div>
</template>

<script>
import { mapValues } from 'lodash'

import InputDatetimeLocal from '@/components/InputDatetimeLocal.vue'
import DisplayLocation from '@/components/DisplayLocation.vue'
import DisplayImage from '@/components/DisplayImage.vue'
import DisplayMasked from '@/components/DisplayMasked.vue'
import { omitBy } from '@/utils/omit.js'
import { fauxOptions } from './OptionsShared.js'

export default {
  name: 'OptionsDisplay',
  components: {
    InputDatetimeLocal,
    DisplayLocation,
    DisplayImage,
    DisplayMasked
  },
  props: {
    value: Object,
    fields: Object,
    omitFields: {
      type: Function,
      default() {}, // e.g. field => field.read_only
    },
  },
  computed: {
    fieldsFiltered() {
      let fields = this.fields || fauxOptions(this.value)
      fields = omitBy(fields, this.omitFields)
      fields = mapValues(fields, i => ({...i, type: i.type?.toLowerCase()}))
      return fields
    },
  },
}
</script>
